import { useQuery } from "react-query";
import { SRLWrapper } from "simple-react-lightbox";
import SimpleReactLightbox from "simple-react-lightbox";

import styled from "styled-components";
import { getSingleImageGallery } from "../../api/api";
import { ImagesEntity } from "../../types/gallery";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";

interface IProps {
  id?: string;
}
const SingleGallery = (props: IProps) => {
  let { id } = useParams(); 
  const { t, i18n } = useTranslation();


  const {
    isLoading,
    error,
    data,
    isFetching,
  }: any = useQuery("SingleImageGalleryData", () => getSingleImageGallery({id:id||"1", language:i18n.language}));

  if (isLoading) return <div></div>;

  console.log(data);

  return (
      <InnerPageLayout>
            <SimpleReactLightbox>

        <Container className="Container">
          <h4 className="shape-round mb-lg-5 pb-5">{t("ألبوم الصور")}</h4>

          <SRLWrapper>
            {data.data.images.map((item: ImagesEntity) => (
              <Image src={`${process.env.REACT_APP_CMS}${item?.url}`} />
            ))}
          </SRLWrapper>
        </Container>
        </SimpleReactLightbox>

      </InnerPageLayout>
  );
};

const Image = styled.img`
  height: 200px;
`;

const Container = styled.div`
  margin: 40px;
  div {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: fit-content;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
  }
`;

export default SingleGallery;
